export const DamageKind = {
    Equipment: 'Equipment',
    Vehicle: 'Vehicle',
} as const

export type DamageKind = (typeof DamageKind)[keyof typeof DamageKind]

export class CompanyDamageReport {
    id!: string
    indexId!: number
    damageKind: DamageKind | string = DamageKind.Equipment
    incidentDateTime?: Date | string | null
    location?: string | null
    reportedByUserId?: string | null
    foremanSuperintendent?: string | null
    assetNumber?: string | null
    telephoneNumber?: string | null
    dotClassification?: string | null
    drugTestPerformed = false
    photosTakenAttached = false
    anyoneInjured = false
    injuredWho?: string | null
    typeOfInjuries?: string | null
    anyoneTransported = false
    transportedWhere?: string | null
    detailsOfWhatHappened?: string | null
    investigationRevealed?: string | null
    disciplinaryActionGiven?: string | null
    correctiveAction?: string | null
    employeeSignature?: string | null
    signedOn?: Date | string | null
    notes?: string | null
    involvesThirdParty = false
    thirdPartyInformation?: string | null
    policeDispatched = false
    policeCaseNumber?: string | null
    fireDispatched = false
    emsDispatched = false
    createdOn?: Date | string | null
    createdByUserId?: string | null
    archived!: boolean
    imageUrls: string[] = []
    imageFileNames: string[] = []

    // Populated by the API for grid display (not sent back on save).
    reportedByName?: string | null

    static createNew(): CompanyDamageReport {
        const report = new CompanyDamageReport()
        report.id = crypto.randomUUID()
        report.damageKind = DamageKind.Equipment
        return report
    }
}
